import React from 'react';
import GongqiFormItemControl from './GongqiFormItemControl';
import FormItemImage from '../FormItemImage';
import FormItemUtil from '../../utils/FormItemUtil';

export default class FormImageControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormImageControl";
        //this.contextMenuData.beforeMenuShow = this.beforeContextMenuShow.bind(this);
	}

	getProperty_MultipleImage()
	{
		return this.properties.MultipleImage;
	}

	getProperty_URL()
	{
		return this.properties.URL;
	}

	getProperty_FailureImage()
	{
		return this.properties.FailureImage;
	}

	getProperty_Suffix()
	{
		return this.properties.Suffix;
	}

	getProperty_LayoutMode()
	{
		if(this.properties.hasOwnProperty("LayoutMode"))
			return this.properties.LayoutMode;
		return this.properties.ImageLayoutMode;
	}

	upLoaderClickHandler(event)
	{
		alert("上传点击");
	}

	getStyle()
	{		
		let width =this.getProperty_Width();
		let height=this.getProperty_Height();
		let parentLayout = this.parentXML.Properties.Layout.Value;
		let style = {flex:"0 0 auto"};
	    if(parentLayout == "horizontal")
	    {
	    	let _width = this.xml.Properties.Width.Value;
	    	if(_width == undefined)
	    		_width = "";
	    	if(_width == "")
	    		_width = "200";
			if(width)
				_width = width;
			let flexGrow = 100;
			let fixedWidth = false;
			
			let iex = _width.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _width.substring(0,iex);
			}
			
			if(iex==-1&&_width != "")
			{
				flexGrow = _width+"px";
				fixedWidth = true;
			}	
			
			if(!fixedWidth)style["flexGrow"] = flexGrow; 
			else style["width"] = flexGrow;

			let _height = this.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "")
				_height = "200";
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.xml.Properties.Height.Value;
	    	if(_height==undefined)
	    		_height = "";
			let flexGrow = 100;
			let fixedHeight = false;
			if(_height == "")
				_height = "200"
			if(height)
				_height = height;
			let iex = _height.indexOf("%");
			if(iex!=-1)
			{
				flexGrow = _height.substring(0,iex);
			}
			if(iex==-1&&_height != "")
			{
				flexGrow = _height+"px";
				fixedHeight = true;
			}	
			
			
			if(!fixedHeight)style["flexGrow"] = flexGrow; 
			else style["height"] = flexGrow;

			let _width = this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "")
				_width = "200";
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		
		return style;
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
	}

	getProperty_AllowEdit_Final()
	{
		if(this.group && (this.group.getCurRecVersion() < 0 || this.group.isCurrentRecordModified()))
			return false;
		return super.getProperty_AllowEdit_Final();
	}

	getComponentInstance(parent,forLookup)
	{
		let label = this.getProperty_Label();
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
	  	this.component = <FormItemImage key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} multiple={this.getProperty_MultipleImage()}
                label={label} customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId} control={this}
                group={this.group} initRecord={this.group?this.group.currentRecord:null} url={this.getProperty_URL()} failureImage={this.getProperty_FailureImage()}
                contextMenuData={this.contextMenuData} suffix={this.getProperty_Suffix()} {...commonProps}
                />;
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemImageControl.js